import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSimCard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSimCard1"><Path d="M8.5 11.5H15.5V17.5H8.5V11.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M4.5 2.5H14.5L19.5 7.5V21.5H4.5V2.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconSimCard1;
